import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PAGE_TITLES = {
  '/': 'Overview',
  '/login': 'Login',
  '/register': 'Register',
  '/organizations': 'Organizations',
  '/no-organization': 'No Organization',
  '/onboarding': 'Onboarding',
  '/transactions': 'Transactions',
  '/tags': 'Tags',
  '/tagging-rules': 'Tagging Rules',
  '/tagging-rules/new': 'New Tagging Rule',
  '/charts': 'Charts',
  '/analytics': 'Analytics',
  '/analytics/tag-drill-down': 'Tag Drill Down',
  '/analytics/income-expense-flow': 'Income & Expense Flow',
  '/metrics': 'Metrics',
  '/customers': 'Customers',
  '/valuation/dcf': 'DCF Valuation',
  '/forecasts/revenue': 'Revenue Forecast',
  '/data-sources': 'Data Sources',
  '/data-sources/add': 'Add Data Source',
  '/ai-chat': 'AI Chat',
  '/ai-categorize': 'AI Categorize',
  '/setup': 'Setup',
  '/user-management': 'User Management',
  '/demo-dash': 'Demo Dashboard',
};

function getTitle(pathname) {
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];

  // Handle dynamic routes
  if (pathname.startsWith('/tagging-rules/') && pathname.endsWith('/edit')) return 'Edit Tagging Rule';
  if (pathname.startsWith('/organizations/') && pathname.endsWith('/edit')) return 'Edit Organization';
  if (pathname.startsWith('/organizations/') && pathname.endsWith('/users')) return 'Organization Users';
  if (pathname.startsWith('/data-sources/') && pathname.endsWith('/edit')) return 'Edit Data Source';
  if (pathname.startsWith('/invitation/')) return 'Accept Invitation';

  return null;
}

export default function usePageTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageTitle = getTitle(pathname);
    document.title = pageTitle ? `${pageTitle} | Refinal.ai` : 'Refinal.ai';
  }, [pathname]);
}
